export default "__VITE_ASSET__SrnaCuZX__"